
import React from "react";
import { Breadcrumbs, Link as MuiLink, Typography, Box } from "@mui/material";

const BreadcrumbsBar = ({ crumbs }) => {
  return (
    <Box display="flex" justifyContent="center" mt={6} mb={4}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator=">"
        sx={{
          fontSize: "1.25rem",
          "& .MuiBreadcrumbs-separator": {
            fontSize: "1.25rem",
            fontWeight: "bold",
            mx: 1.5
          }
        }}
      >
        {crumbs.map((crumb, index) =>
          crumb.current ? (
            <Typography
              key={index}
              color="text.primary"
              sx={{
                display: "inline-block",
                fontSize: "1.25rem",
                fontFamily: "Segoe UI Semibold, sans-serif",
                fontWeight: "bold",
                py: 1
              }}
            >
              {crumb.label}
            </Typography>
          ) : (
            <MuiLink
              key={index}
              component="a"
              href={crumb.path}
              underline="hover"
              color="inherit"
              sx={{
                cursor: "pointer",
                padding: "8px 12px",
                display: "inline-block",
                py: 1,
                px: 1.5,
                borderRadius: "4px",
                fontSize: "1.25rem",
                fontFamily: "Segoe UI Semibold, sans-serif",
              }}
            >
              {crumb.label}
            </MuiLink>
          )
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbsBar;
